<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container">
        <div class="row">
          <div class="col-md-12">

            <h1 v-if="project">{{project.Info.title}}</h1>

            <div class="section-tab">
              <ul>
                <li>1 - Quanto quero doar</li>
                <li class="active">2 - Meios de pagamento</li>
                <li>3 - Compartilhar</li>
              </ul>
            </div>

            <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{msg}}
              <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="payment-method row" v-if="hasPagarme">
              <div class="method pagarme">
                <a href="" v-on:click.stop.prevent="methodPagarme()"><img :src="logoPagarme"/></a>
              </div>
            </div>

            <!-- <h5 v-if="hasPagseguro">Ou</h5>

            <div class="payment-method row" v-if="hasPagseguro">
              <div class="method pagseguro">
                <a href="" v-on:click.stop.prevent="methodPagseguro()"><img :src="logoPagseguro"/></a>
              </div>
            </div> -->

            <!-- <h5 v-if="(hasPagseguro || hasPagarme) && hasPaypal">Ou</h5> -->
            <h5 v-if="(hasPagarme) && hasPaypal">Ou</h5>

            <div class="payment-method row" v-if="hasPaypal">
              <div class="method paypal">
                <a id="paypal-button" href="" v-on:click.stop.prevent="methodPaypal()"><img :src="logoPaypal"/></a>
              </div>
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" ref="formPaypal" target="_blank">
                <div v-if="donation.type == 'monthly'">
                  <input type="hidden" name="cmd" value="_xclick-subscriptions">
                  <input type="hidden" name="a3" :value="donation.value.toFixed(2)">
                  <input type="hidden" name="p3" value="1">
                  <input type="hidden" name="t3" value="M">
                  <input type="hidden" name="src" value="1">
                  <input type="hidden" name="sra" value="1">
                  <input type="hidden" name="no_note" value="1">
                </div>
                <div v-else>
                  <input type="hidden" name="cmd" value="_xclick">
                  <input type="hidden" name="amount" id="amountx" :value="donation.value.toFixed(2)">
                </div>
                <input type="hidden" name="business" :value="project.PaypalAccount.email">
                <input type="hidden" name="no_shipping" value="1">
                <input type="hidden" name="item_name" :value="'Doação para ' + project.Info.title">
                <input type="hidden" name="item_number" :value="donation.DonationId">
                <input type="hidden" name="charset" value="utf-8">
                <input type="hidden" name="currency_code" value="BRL">
                <input type="hidden" name="return" :value="'https://click2giv.com/project/donation/finish/' + donation.DonationId">
                <input type="hidden" name="notify_url" :value="API.Projects.processNotificationPaypal + donation.DonationId">
                <input type="hidden" name="cancel_return" :value="'https://click2giv.com/project/donation/method/' + donation.DonationId">
              </form>
            </div>

          </div>
        </div>

      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>

  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import pagarmeLogo from '../assets/images/cartoes_pagar.png'
import pagseguroLogo from '../assets/images/Pagseguro.png'
import paypalLogo from '../assets/images/paypal_home.png'
import auth from '../services/auth'
import Loading from './includes/Loading'
import Functions from '../utils/functions'
import { API } from '../services/api'

export default {
  name: 'DonationMethod',
  components: {
    Header,
    Footer,
    Loading
  },
  data () {
    return {
      logoPagarme: pagarmeLogo,
      logoPagseguro: pagseguroLogo,
      logoPaypal: paypalLogo,
      loading: true,
      donation: null,
      project: null,
      hasPagarme: false,
      hasPagseguro: false,
      hasPaypal: false,
      showMsg: false,
      msg: '',
      user: null,
      API: API,
      paypalApprovalUrl: null,
      paypalExecuteUrl: null,
      ppp: null
    }
  },
  created(){
    this.loadDonation();
  },
  mounted(){
    
  },
  methods: {
    loadProfile(){
      if(auth.isAuth()){
        this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
          this.user = response.body.user;
        }, (err) => {
          this.$router.push('/project/' + this.$route.params.slug);
        });
      }
    },
    loadDonation(){
      this.$http.get(API.Projects.getDonation + this.$route.params.DonationId, {headers: auth.getHeaders()}).then((res) => {
        this.donation = res.body;
        if(this.donation.paymentStatus == 'paid' || this.donation.paymentStatus == 'waiting_payment'){
          this.$router.push('/');
        }
        this.loadProject()
      }, (err) => {
        this.$router.push('/');
      });
    },
    loadProject(){
      this.$http.get(API.Projects.getProject + this.donation.ProjectId, {headers: auth.getHeaders()}).then((res) => {
        this.project = res.body[0]
        if(this.project.PagarmeAccount && this.project.PagarmeAccount.receiverId){
          this.hasPagarme = true;
        }
        // if(this.project.PagseguroAccount && this.project.PagseguroAccount.email && this.project.PagseguroAccount.email.length > 0){
        //   this.hasPagseguro = true;
        // }
        if(this.project.PaypalAccount && this.project.PaypalAccount.email && this.project.PaypalAccount.email.length > 0){
          this.hasPaypal = true
        }
        this.loading = false;
      }, (err) => {
        this.$router.push('/');
      });
    },
    methodPagarme(){
      // alert("Forma de pagamento indisponível. Tente novamente mais tarde.");
      var $this = this;
      var donation = this.donation;
      // inicia a instância do checkout
      var checkout = new PagarMeCheckout.Checkout({
        encryption_key: 'ek_live_eMgIJ1T98Ru5U0K8hDHHkwRp8yLisM',
        // encryption_key: 'ek_test_BGBezpiqx7ZKxMAvh2d7azSUDrNZBo',
        success: function(data) {
          $this.loading = true;
          var params = {paymentMethod: data.payment_method, token: data.token};
          if($this.donation.type == 'monthly'){
            params = {paymentMethod: data.payment_method, token: data.token, cardHash: data.card_hash, customer: data.customer}
          }
          $this.$http.post(API.Projects.processPaymentPagarme + $this.donation.DonationId, params, 
          {headers: auth.getHeaders()}).then((res) => {
            var donation = res.body.donation;
            var postback = JSON.parse(donation.postback);
            $this.$router.push('/project/donation/finish/' + $this.donation.DonationId);

          }, (error) => {
            if(error.body.message){
              $this.msg = error.body.message;
            }else{
              $this.msg = 'Ocorreu um erro no processamento do seu pagamento. Tente novamente.';
            }
            $this.showMsg = true;
            $this.loading = false;
          });
        },
        error: function(err) {
          console.log(err)
        },
        close: function() {
          console.log('The modal has been closed.');
        }
      });

      // Obs.: é necessário passar os valores boolean como string
      checkout.open({
        amount: donation.value * 100,
        buttonText: 'Pagar',
        buttonClass: 'botao-pagamento',
        customerData: 'true',
        createToken: ($this.donation.type == 'single') ? 'true' : 'false',
        paymentMethods: 'credit_card, boleto',
        // paymentMethods: 'boleto',
        uiColor: '#00AE39',
        postbackUrl: API.Projects.processNotificationPagarme + $this.donation.DonationId,
        items: [{
          "id": $this.donation.DonationId,
          "title": "Doação para " + $this.project.Info.title,
          "unit_price": $this.donation.value + '00',
          "quantity": 1,
          "tangible": "false"
        }]
      });
    },
    // methodPagseguro(){
    //   var $this = this;
    //   this.loading = true;
    //   var parser = new DOMParser();

    //   this.$http.post(API.Projects.processPaymentPagseguro + this.donation.DonationId,
    //   {requestType: 'prepare', pagseguroEmail: this.project.PagseguroAccount.email, pagseguroToken: this.project.PagseguroAccount.token,
    //    donation: this.donation, project: this.project, username: this.user.Info.fullname, notificationUrl: API.Projects.processNotificationPagseguro + this.donation.DonationId}, 
    //   {headers: auth.getHeaders()})
    //   .then((res) => {
    //     $this.loading = false;
    //     var xml = parser.parseFromString(res.body.xml, "text/xml");
    //     var code = xml.getElementsByTagName("code")[0].childNodes[0].nodeValue;

    //     if($this.donation.type == 'monthly'){
    //       window.open("https://pagseguro.uol.com.br/v2/pre-approvals/request.html?code=" + code);
    //     }else{
    //       var isOpenLightbox = PagSeguroLightbox({code: code}, 
    //         {
    //           success: function(transactionCode){
    //             $this.$http.post(API.Projects.processPaymentPagseguro + this.donation.DonationId,
    //             {requestType: 'finish', transactionCode: transactionCode}, 
    //             {headers: auth.getHeaders()}).then((r) => {
    //               $this.$router.push('/project/donation/finish/' + $this.donation.DonationId);
    //             })
    //           },
    //           abort: function(){
    //             console.log("Pagseguro Modal was closed.");
    //           }
    //         });
    //       // Redirecionando o cliente caso o navegador não tenha suporte ao Lightbox
    //       if (!isOpenLightbox){
    //         window.open("https://pagseguro.uol.com.br/v2/checkout/payment.html?code=" + code);
    //       }
    //     }
        
    //   }, (err) => {
    //     $this.msg = "Ocorreu um erro ao processar o pagamento via Pagseguro."
    //     $this.showMsg = true;
    //     $this.loading = false;
    //     console.log(err.body)
    //   });
    // },
    methodPaypal(){
      this.$refs.formPaypal.submit();
    },
    onContinuePaypalPayment(rememberedCards, payerId, paymentId){
      console.log(rememberedCards, payerId, paymentId);
    },
    onErrorPaypalPayment(data){
      console.log("ERRO");
      console.log(data);
    },
    openPaypalModalAfterData()
    {
      if(this.user.Info.email && this.user.Info.cpf){
        //Persistir os dados do usuário
        this.methodPaypal()
      }else{
        this.msg = "Você deve preencher os dados obrigatórios antes de continuar.";
        this.showMsg = true;
      }
    },
    hideMsg(){
      this.msg = "";
      this.showMsg = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
    padding-bottom: 150px;
  }
  h1{
    text-align: center;
    font-family: RalewayBold;
    color: #00ae39;
  }

  .section-tab{
    width: 100%;
    margin-top: 20px;

    ul{
      list-style: none;
      padding: 0;
      padding-top: 20px;
      border-bottom: thin solid #ccc;

      li{
        display: inline-block;
        padding-bottom: 10px;
        margin-right: 20px;
        font-size: 20px;
        @media screen and(max-width: 767px){
          display: none;
          margin-right: 0px;
        }
        cursor: default;
        &.active{
          color: #00ae39;
          font-weight: bold;
          border-bottom: 3px solid #00ae39;
          @media screen and(max-width: 767px){
            display: block;
            text-align: center;;
          }
        }
      }
    }
  }

  h5{
    position: relative;
    text-align: center;
    margin: 30px 0px;
    font-family: RalewayRegular;

    &::before{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      right: 0;
    }

    &::after{
      position: absolute;
      content: " ";
      width: 35%;
      border-bottom: 1px solid #d9d9d9;
      height: 1px;
      top: 50%;
      left: 0;
    }
  }

  .payment-method{
    margin-top: 20px;

    .method{
      margin: 0 auto;
    }
    img{
      width: 280px;
    }
  }

  #paypal-button{
    display: block;
  }

  form{
    display: none;
  }

  #ppplusDiv{
    width: 765px;

    @media screen and(max-width: 991px){
      width: 455px;
    }
  }

  #continueButton{
    display: block;
    margin: 0 auto;
    color: #fff;
    background-color: #003087;
    border-radius: 5px;
    padding: 10px;
    font-size: 22px;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/DonationMethod.vue